import { render, staticRenderFns } from "./ResultTopicCarousel.vue?vue&type=template&id=6c0416ae&scoped=true"
import script from "./ResultTopicCarousel.vue?vue&type=script&lang=js"
export * from "./ResultTopicCarousel.vue?vue&type=script&lang=js"
import style0 from "./ResultTopicCarousel.vue?vue&type=style&index=0&id=6c0416ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0416ae",
  null
  
)

export default component.exports